// Match chat messages the server pushes as moderated_match_chat (to mods who
// joined a match's chat) go from ServerMessageController to the match page.

const listeners = new Set();

export function subscribeToModeratedMatchChat(listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

export function publishModeratedMatchChat(message) {
	listeners.forEach((listener) => listener(message));
}
